const loadImage = async (src: string): Promise<HTMLImageElement> => {
  const image = new Image()
  image.crossOrigin = "anonymous"
  image.src = src

  return new Promise((resolve, reject) => {
    image.addEventListener("load", () => resolve(image), { once: true })
    image.addEventListener("error", () => reject(new Error("图片加载失败")), {
      once: true,
    })
  })
}

export const buildWhiteJpegDataUrl = async (url: string) => {
  const image = await loadImage(url)
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")

  if (!ctx) {
    throw new Error("当前浏览器不支持图片处理")
  }

  canvas.width = image.width
  canvas.height = image.height
  ctx.fillStyle = "#fff"
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(image, 0, 0)

  return canvas.toDataURL("image/jpeg", 0.95)
}

export const dataUrlToFile = (dataUrl: string, filename: string) => {
  const [header, body] = dataUrl.split(",")
  const mime = header.match(/:(.*?);/)?.[1] || "image/jpeg"
  const binary = window.atob(body)
  const bytes = new Uint8Array(binary.length)

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }

  return new File([bytes], filename, { type: mime })
}
